// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-modal-overlay.payment-modal .react-modal {
  padding-top: 1rem;
  top: 15%;
  left: calc(50% - 16rem);
  width: 32rem;
  height: 35rem;
  height: -moz-fit-content;
  height: fit-content;
  box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);
  border-radius: 0.5rem;
}
.react-modal-overlay.payment-modal.expanded .react-modal {
  height: 49rem;
  height: -moz-fit-content;
  height: fit-content;
}
.react-modal-overlay.payment-modal .edit {
  cursor: pointer;
}
.react-modal-overlay.payment-modal .logo-wrapper {
  text-align: center;
}
.react-modal-overlay.payment-modal .logo-wrapper img.logo {
  height: 5rem;
  margin-bottom: 2rem;
  margin-top: 2rem;
}
.react-modal-overlay.payment-modal .purchase-button {
  padding-top: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/Stripe/PaymentModal.scss"],"names":[],"mappings":"AAGE;EACE,iBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;EAAA,mBAAA;EAGA,sDAAA;EACA,qBAAA;AAFJ;AAKI;EACE,aAAA;EACA,wBAAA;EAAA,mBAAA;AAHN;AAME;EACE,eAAA;AAJJ;AAME;EACE,kBAAA;AAJJ;AAKI;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;AAHN;AAME;EACE,iBAAA;AAJJ","sourcesContent":["@import '~/Styles/Variables';\n\n.react-modal-overlay.payment-modal {\n  .react-modal {\n    padding-top: 1rem;\n    top: 15%;\n    left: calc(50% - 16rem);\n    width: 32rem;\n    height: 35rem;\n    height: fit-content;\n    -webkit-box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n    -moz-box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n    box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n    border-radius: 0.5rem;\n  }\n  &.expanded {\n    .react-modal {\n      height: 49rem;\n      height: fit-content;\n    }\n  }\n  .edit {\n    cursor: pointer;\n  }\n  .logo-wrapper {\n    text-align: center;\n    img.logo {\n      height: 5rem;\n      margin-bottom: 2rem;\n      margin-top: 2rem;\n    }\n  }\n  .purchase-button {\n    padding-top: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
